<template>
  <div class="container">
    <div class="head">
      <div class="head-title">新闻中心</div>
      <div @click="$router.push({ name: 'xinwen' })" class="head-more">更多 >></div>
    </div>
    <div class="con">
      <div class="con-left">
        <ul class="list">
          <li @click="openDetail(item)" class="list-item" v-for="item in list" :key="item">
            <div class="list-item-date">
              <div class="list-item-date-1">{{item.addTime.slice(0,7)}}</div>
              <div class="list-item-date-2">{{item.addTime.slice(8,10)}}</div>
            </div>
            <div class="list-item-title">{{item.headline}}</div>
          </li>
        </ul>
      </div>

      <div class="con-right">
        <div class="con-right-carousel">
          <a-carousel :autoplay="true" arrows>
            <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
              <a-icon type="left-circle" />
            </div>
            <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
              <a-icon type="right-circle" />
            </div>
            <div @click="goDetail(item)" v-for="(item, i) in instruments" :key="i" class="con-right-carousel-box">
              <img :src="'/prod-api'+item.pictureUrl" alt="" class="con-right-carousel-box-img">
              <div class="con-right-carousel-box-title">{{item.assetName}}</div>
            </div>
          </a-carousel>
        </div>

        <div class="con-right-fastTrack">
          <div class="head">
            <div class="head-title">快速通道</div>
          </div>
          <ul class="con-right-fastTrack-list">
            <li @click="$router.push({name: 'InstrumentList'})" class="con-right-fastTrack-list-item">
              <img src="../../assets/images/kj_1.png" class="con-right-fastTrack-list-item-img" alt="">
              <div class="con-right-fastTrack-list-item-title">仪器预约</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  data () {
    return {
      list: [],
      loading: true,
      instruments: [],
    }
  },
  created () {
    this.getInstruments()
    this.onload()
  },
  methods: {
    onload () {
      let parameter = {
        pageNum: 1,
        pageSize: 6,
        type: 2
      }
      http('/system/announcement/getList', 'POST', parameter).then(res => {
        this.loading = false
        if (res.success) {
          this.list = res.data.resultList
        }
      })
    },
    openDetail(item) {
      let url = this.$router.resolve({ name: 'xinwenDetail', query: { noticeId: item.id, type: 2 } })
      window.open(url.href, '_blank')
    },
    getInstruments() {
      let parameter = {
        pageNum: 1,
        pageSize: 10
      }
      http('/reservation/openTheInstrument', 'POST', parameter).then(res => {
        if (res.success) {
          this.loading = false
          this.instruments = res.data.resultList
        }
      })
    },
    goDetail(data) {
      this.$router.push({ name: 'DayiDetail', query: { code: data.assetCode, id: data.id } })
    },
  }
}
</script>

<style lang="less" scoped>
.con {
  display: flex;
  justify-content: space-between;
  &-left {
    width: 380px;
    height: 470px;
    margin: 12px 0 0 0;
    overflow: hidden;
  }
  &-right {
    &-carousel {
      margin-top: 12px;
      width: 372px;
      height: 275px;
      overflow: hidden;
      position: relative;
      &:hover {
        .ant-carousel /deep/ .custom-slick-arrow {
          opacity: 0.5;
        }
      }
      &-box {
        height: 275px;
        width: 100%;
        position: relative;
        &-img {
          width: 100%;
          height: 100%;
        }
        &-title {
          min-width: 141px;
          height: 40px;
          background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #519bcd 50%, rgba(0, 0, 0, 0) 100%);
          opacity: 0.6;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 40px;
          text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
          text-align: center;
          position: absolute;
          left: calc(50% - 70px);
          top: calc(50% - 20px);
          user-select: none;
        }
      }
    }
    &-fastTrack {
      width: 372px;
      height: 170px;
      float: right;
      margin: 15px 0px 0px 0px;
      padding: 10px 15px 10px 10px;
      &-list {
        padding: 20px 15px 0;
        list-style-type: none;
        display: flex;
        justify-content: space-between;
        &-item {
          text-align: center;
          cursor: pointer;
          &-img {
            width: 50px;
            height: 50px;
          }
          &-title {
            color: #333333;
            font-size: 12px;
            margin-top: 12px;
          }
        }
      }
    }
  }
}
.list {
  padding-left: 0;
  list-style-type: none;
  &-item {
    margin-top: 10px;
    height: 68px;
    border-bottom: 1px #dfdfdf dashed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    &-date {
      height: 55px;
      width: 55px;
      text-align: center;
      border: 1px solid #dfdfdf;
      &-1 {
        display: block;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #a03638;
        color: #fff;
        font-size: 12px;
        letter-spacing: 0;
      }
      &-2 {
        display: block;
        text-align: center;
        font-size: 24px;
      }
    }
    &-title {
      width: 305px;
      line-height: 20px;
      box-sizing: border-box;
      &:hover {
        color: #96cdff;
      }
    }
  }

}
.ant-carousel /deep/ .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.1;
  transition: .3s;
}
.ant-carousel /deep/ .custom-slick-arrow:before {
  display: none;
}
</style>
<style lang="less">
.head {
  width: 100%;
  height: 38px;
  background-image: url(../../assets/images/pulic_title_bg.jpg);
  background-position: left bottom;
  background-repeat: no-repeat;
  display: flex;
  justify-content: space-between;
  &-title {
    color: #2e2b2b;
    line-height: 28px;
    font: 14px/1.5 "\u5fae\u8f6f\u96c5\u9ed1", "\5FAE\8F6F\96C5\9ED1", tahoma, arial, "\5b8b\4f53", sans-serif;
    letter-spacing: 1px;
    font-size: 16px;
  }
  &-more {
    font-size: 12px;
    color: #787878;
    line-height: 28px;
    cursor: pointer;
  }
}
</style>